import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiV2ReservationgroupElFindRemovedParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiV2ReservationgroupElFindRemovedParams, unknown>

const fetchReservationGroupRemovedList = async (params: ApiV2ReservationgroupElFindRemovedParams) => {
  const { data } = await apiClient.v2.apiV2ReservationgroupElFindRemoved(params);
  return checkApiResponse(data);
}

export const v2ReservationGroupRemovedKeys = {
  all: [QUERY_KEY.v2apiV2ReservationgroupElFindRemoved] as const,
  list: (params: ApiV2ReservationgroupElFindRemovedParams) => [...v2ReservationGroupRemovedKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(v2ReservationGroupFindRemovedQueryOptions(params))` */
export const v2ReservationGroupFindRemovedQueryOptions = (params: ApiV2ReservationgroupElFindRemovedParams) => ({
  queryKey: v2ReservationGroupRemovedKeys.list(params),
  queryFn: () => fetchReservationGroupRemovedList(params),
})

export const useV2ReservationGroupFindRemovedQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: v2ReservationGroupRemovedKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchReservationGroupRemovedList(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
